module.exports = __webpack_public_path__ + "img/facebook.af1f45c2.png";